export function explicitInjectedProviderDetected() {
    const _window = typeof window !== 'undefined' ? window : undefined;
    if (typeof _window === 'undefined' || typeof _window.ethereum === 'undefined')
        return false;
    return !!_window.ethereum;
}
